import { useContext } from 'react'
import { SettingsContext } from '../components/context/settingsContext'

export const useSettings = () => useContext(SettingsContext)
